import { arrayExaustivo } from '../types';
import {
  FUNCIONALIDADES_PLANOS_MINIMOS as FUNCIONALIDADES_PLANOS_MINIMOS_GERADOS,
  PLANOS_ORDENADOS as PLANOS_ORDENADOS_GERADOS,
} from './constantes.gen';
import type { ApiSchema } from './index';

export { CLIENTE_IDS, FUNCIONALIDADES_BANCO } from './constantes.gen';

export type Permissoes = ApiSchema<'Enums.Permissoes'>;
export type Usuario = ApiSchema<'Usuarios.UsuarioAutenticadoDTO'>;
export type TipoUsuario = ApiSchema<'Enums.UserType'>;
export type SolicitacaoStatus = ApiSchema<'Enums.SolicitacaoStatus'>;
export type SolicitacaoTipo = ApiSchema<'Enums.SolicitacaoTipo'>;
export type TipoPrivilegio = ApiSchema<'Models.TipoPrivilegio'>;
export type TipoConta = ApiSchema<'Geral.TipoConta'>;
export type Plano = ApiSchema<'Models.TipoPlano'>;
export type ProblemDetails = ApiSchema<'Mvc.ProblemDetails'>;

export type FuncionalidadeApi = ApiSchema<'Models.Funcionalidade'>;
export type Funcionalidade =
  | FuncionalidadeApi
  | 'ChatCorporativo'
  | 'ControleEPI'
  | 'PesquisaClima'
  | 'PlanoCargos';

export const PRIVILEGIOS = arrayExaustivo<TipoPrivilegio>()(['Owner', 'User']);

export const TIPOS_CONTAS = arrayExaustivo<TipoConta>()([
  'ClienteFinal',
  'Revenda',
]);

// A ordem vem do valor numérico do enum TipoPlano; o arrayExaustivo garante que o
// `constantes.gen.ts` e o `v1.gen.d.ts` concordam sobre quais planos existem.
export const PLANOS_ORDENADOS = arrayExaustivo<Plano>()(
  PLANOS_ORDENADOS_GERADOS,
);

// O `satisfies` faz um rename de funcionalidade ou de plano no backend quebrar aqui, e não só
// nos pontos que leem uma chave específica.
export const FUNCIONALIDADES_PLANOS_MINIMOS =
  FUNCIONALIDADES_PLANOS_MINIMOS_GERADOS satisfies Partial<
    Record<FuncionalidadeApi, Plano>
  >;

/** Nomes comerciais dos planos, iguais em todos os idiomas. */
export const ROTULOS_PLANOS: Record<Plano, string> = {
  Gateway: 'Gateway',
  Basic: 'Basic',
  PRO: 'Pro',
  Ultimate: 'Ultimate',
  Corporate: 'Corporate',
};

export const FUNCIONALIDADES_API = arrayExaustivo<FuncionalidadeApi>()([
  'AdmissaoDigital',
  'AuditoriaPreventiva',
  'Beneficios',
  'ControleFerias',
  'FilaExpressaImportacaoRegistros',
  'GestaoArquivos',
  'IASuporteAutomatico',
  'MaisRequisicoesIntegracaoExterna',
]);

export const FUNCIONALIDADES = arrayExaustivo<Funcionalidade>()([
  ...FUNCIONALIDADES_API,
  'ChatCorporativo',
  'ControleEPI',
  'PesquisaClima',
  'PlanoCargos',
]);
